Jelly.Connections.Eventbrite_API_Base = "https://www.eventbriteapi.com/v3/";

Jelly.Connections.Eventbrite_Events = function(Parameters) { 

	var Continue_Eventbrite_Events = function (){
		
		// Init sync variables
		var Upcoming_Events = [];
		var Now = Date.now();
		var Eventbrite_Request_Endpoint = "organizations/" + Parameters.Eventbrite_Organization + "/events/";
		var Eventbrite_Request_Parameters = {
				status: "live"
			,	order_by: "start_asc"
			, time_filter: "current_future"
			, expand: "logo"
			, token: Parameters.Eventbrite_Token
		};

		// Handle events
		var Handle_Events = function (API_Response, API_Response_Status) { 
			var Eventbrite_Events = API_Response.events;

			// Add each upcoming event
			// TODO - if we needed additional filters, we'd add them here
			for (var Event_Index in Eventbrite_Events) {
	    	if (Eventbrite_Events.hasOwnProperty(Event_Index)) {
	    		var Current_Event = Eventbrite_Events[Event_Index];
	    		
	    		// Filter out events we already have added
	    		if (Parameters.May_Have_Already_Added_Events.indexOf(Current_Event.id) == -1)
		    		Upcoming_Events.push(Jelly.Connections.Parse_Eventbrite_Event(Current_Event));
	    	}
	    }

	    // Get next events
	    if (API_Response.pagination.has_more_items) { 

	    	// Get next page token
	    	Eventbrite_Request_Parameters.continuation = API_Response.pagination.continuation;

	    	// Get next page
	    	$.getJSON(Jelly.Connections.Eventbrite_API_Base + Eventbrite_Request_Endpoint + "?" + $.param(Eventbrite_Request_Parameters), null, Handle_Events);
	    }

	    // When there are no pages left, sort and display the list
   		else { 
   			if (Upcoming_Events.length) {
				// Sort by start time
				Upcoming_Events.sort(function (a, b) {
				  return a.sort_time - b.sort_time;
				});			   		

				// Display in list
				$("#" + Parameters.Namespace + "_Event_List li.Loading").remove();
			    // $("#" + Parameters.Namespace + "_Event_List_Wrapper .Controls").show();
			    for (var Event_Index in Upcoming_Events) {
			    	if (Upcoming_Events.hasOwnProperty(Event_Index)) {
				    	Jelly.Connections.Add_Eventbrite_Event_To_List({
				    			Input_Namespace: Parameters.Input_Namespace
				    		,	Namespace: Parameters.Namespace
				    		,	Event: Upcoming_Events[Event_Index]
				    		, Token: Parameters.Eventbrite_Token
				    	});
			    	}
			    }
			}
			else {
				$("#" + Parameters.Namespace + "_Event_List li.Loading").remove();
				$("#" + Parameters.Namespace + "_Event_List").append('<li>You have no upcoming events on Eventbrite.</li>');
			} 
   		}
		};

		// Get first page of events
		$.getJSON(Jelly.Connections.Eventbrite_API_Base + Eventbrite_Request_Endpoint + "?" + $.param(Eventbrite_Request_Parameters), null, Handle_Events);
	};

	// TODO - this area would dynamically handle permissions if Eventbrite's API evolves

	Continue_Eventbrite_Events();
};

Jelly.Connections.Parse_Eventbrite_Event = function(Eventbrite_Event) {
	Event_Relevant_Data = {
		id: Eventbrite_Event.id,
		name: Eventbrite_Event.name.text, 
		start_time: Eventbrite_Event.start.local,
		sort_time: moment(Eventbrite_Event.start.utc).format("YYYYMMDDHHmm")
	};

	// console.log(Facebook_Event.cover);
	// console.log(typeof Facebook_Event);
	if (typeof Eventbrite_Event.logo == "object" && Eventbrite_Event.logo)
		Event_Relevant_Data.cover = Eventbrite_Event.logo.original.url;
	return Event_Relevant_Data;
};

Jelly.Connections.Select_Eventbrite_Event = function(Parameters) {
	var Eventbrite_Request_Endpoint = "events/" + Parameters.Event_ID + "/";
	var Eventbrite_Request_Parameters = {
			expand: "logo,ticket_classes,venue"
		, token: Parameters.Token
	};
	$.getJSON(Jelly.Connections.Eventbrite_API_Base + Eventbrite_Request_Endpoint + "?" + $.param(Eventbrite_Request_Parameters), null, function(API_Response, API_Response_Status){

		var Namespace = Parameters.Namespace;

		var Selected_Event = API_Response;

		// Check if available tickets exist

		// Get lowest price ticket, quantity
		var Eventbrite_Lowest_Price_Ticket;
		var Eventbrite_Lowest_Price_Ticket_Including_Free;
		var Eventbrite_Lowest_Price_Ticket_Excluding_Free;
		var Eventbrite_Quantity = 0;

		$.each(Selected_Event.ticket_classes, function(i, Current_Ticket) {
			if (Current_Ticket.hidden != true) {
				Eventbrite_Quantity += Current_Ticket.quantity_total;

				if (
					// No ticket set yet
					!Eventbrite_Lowest_Price_Ticket_Including_Free || 

					// Is free
					!Current_Ticket.cost || 

					// Is cheaper
					Eventbrite_Lowest_Price_Ticket_Including_Free.cost && 
						Current_Ticket.cost.major_value < Eventbrite_Lowest_Price_Ticket_Including_Free.cost
				)
					Eventbrite_Lowest_Price_Ticket_Including_Free = Current_Ticket;

				// If it's not free
				if (Current_Ticket.cost && (
						
						// No non-free ticket set yet
						!Eventbrite_Lowest_Price_Ticket_Excluding_Free || 

						// Is cheaper
						Eventbrite_Lowest_Price_Ticket_Excluding_Free.cost && 
							Current_Ticket.cost.major_value < Eventbrite_Lowest_Price_Ticket_Excluding_Free.cost.major_value
					)
				)
					Eventbrite_Lowest_Price_Ticket_Excluding_Free = Current_Ticket;
			}
		});

		// Set lowest priced ticket to lowest paid, or free if lowest paid doesn't exist
		Eventbrite_Lowest_Price_Ticket = (Eventbrite_Lowest_Price_Ticket_Excluding_Free ? Eventbrite_Lowest_Price_Ticket_Excluding_Free : Eventbrite_Lowest_Price_Ticket_Including_Free);

		// Throw error if there are no available tickets
		if (!Eventbrite_Lowest_Price_Ticket) {
			alert("Error: No tickets are available for this event yet, so we can't import it. Please contact <a href=\"mailto:support@withfriends.co\">support@withfriends.co</a> for help.");
			return;
		}

		// Name 
		Jelly.Actions.Set_Input_Value({ Namespace: Namespace,
			Alias: "Event_Name",
			Value: Selected_Event.name.text
		});

		// Location
		var Address = "";
		if (Selected_Event.venue && Selected_Event.venue.address) {
			Address += Selected_Event.venue.name + ", " + 
				Selected_Event.venue.address.address_1 + ", " + 
				(Selected_Event.venue.address.address_2 ? Selected_Event.venue.address.address_2 + ", " : "") + 
				Selected_Event.venue.address.city + ", " + 
				Selected_Event.venue.address.region + ", " + 
				Selected_Event.venue.address.postal_code + ", " + 
				Selected_Event.venue.address.country
			;
		}

		Jelly.Actions.Set_Input_Value({ Namespace: Namespace,
			Alias: "Location_Address",
			Value: Address
		});

		// Cover
		if (Selected_Event.logo && Selected_Event.logo.original.url) {
			Jelly.Actions.Set_Input_Value({ Namespace: Namespace,
				Alias: "Eventbrite_Cover_URL",
				Value: Selected_Event.logo.original.url
			});
		}

		// Description
		Jelly.Actions.Set_Input_Value({Namespace: Namespace,
			Alias: "Description",
			Value: Selected_Event.description.html
		});

		// Ticket Name 		
		Jelly.Actions.Set_Input_Value({Namespace: Namespace,
			Alias: "New_Tier_1_Name",
			Value: "All Tickets"
		});

		// Capacity
		// console.log(Eventbrite_Quantity);
		// TODO - I think we can actually just get capacity from the top level event lol.
		Jelly.Actions.Set_Input_Value({Namespace: Namespace,
			Alias: "New_Tier_1_Capacity",
			Value: Eventbrite_Quantity
		});

		// Price
		var Eventbrite_Price = (Eventbrite_Lowest_Price_Ticket.cost ? Eventbrite_Lowest_Price_Ticket.cost.major_value : 0);
		Jelly.Actions.Set_Input_Value({Namespace: Namespace,
			Alias: "New_Tier_1_Price",
			Value: Eventbrite_Price
		});

		// Ticket Kind
		if (!Eventbrite_Price) { 
			Jelly.Actions.Set_Input_Value({Namespace: Namespace,
				Alias: "New_Tier_1_Kind",
				Value: 'Free'
			});
		}

		// Start Time
		if (Selected_Event.start) {
			Jelly.Actions.Set_Input_Value({Namespace: Namespace,
				Alias: "New_Tier_1_Start_Time",
				Value: Selected_Event.start.local
			});
		}

		// Eventbrite ID
		Jelly.Actions.Set_Input_Value({Namespace: Namespace,
			Alias: "Eventbrite_ID",
			Value: Parameters.Event_ID
		});

		// Set ticket
		Jelly.Actions.Set_Input_Value({Namespace: Namespace,
			Alias: "Eventbrite_Ticket_ID",
			Value: Eventbrite_Lowest_Price_Ticket.id
		});

		Jelly.Interface.Close_Top_Window();

		// Create weird loading world
		console.log('#' + Namespace);
		$('#' + Namespace).find('.Form').append($('<div style="position: fixed;left: 0;top: 0;bottom: 0;right: 0;background: rgba(0,0,0,.4);z-index: 1;display: flex;align-items: center;justify-content: center;"><span class="Jelly_Loading" style="visibility: visible;width:3rem;height:3rem;border-width:6px !important;"></span></div>'));

		// Submit action
		Jelly.Handlers.Call_Handler_For_Target({
			Event: "Execute", 
			Target: $("#" + Namespace).get(0)
		});
	});
};

Jelly.Connections.Add_Eventbrite_Event_To_List = function(Parameters) {
	Start_Time = moment(Parameters.Event.start_time, moment.ISO_8601).valueOf();
	Now = Date.now();
	$Event_List = $("#" + Parameters.Namespace + "_Event_List");
	$("<li class=\"Event_List_Item" + "\" style=\"cursor:pointer;\" onclick=\"$(this).addClass('Loading');Jelly.Connections.Select_Eventbrite_Event({Namespace: '" + Parameters.Input_Namespace + "', Event_ID: '" + Parameters.Event.id + "', Token: '" + Parameters.Token + "'})\">" + 
		"	<div class=\"Overlay\">" + "<span class=\"Jelly_Loading\"></span>" + "</div>" + 
		"	<div class=\"Cover\">" + 
		"		<div class=\"Image\" style=\"background-image: url(" + Parameters.Event.cover + ");\"></div>" +
		"			<div class=\"Basics\">" + 
		"				<h2 class=\"Title\">" + Parameters.Event.name + "</h2>" + 
		"			</div>" + 
		" 	</div>" +
		" <div class=\"Metadata\">" + 
		"	 <div class=\"Date six_columns ignore_break_point\">" + 
					moment(Start_Time).format("dddd") + ", " + 
					"<br class=\"Mobile_Only\"/> " +  (
						moment(Now).format("GGGG") == moment(Start_Time).format("GGGG") ? 
							moment(Start_Time).format("MMMM D") : 
							moment(Start_Time).format("MMMM D, GGGG")
						) + 
		"		</div>" + 
		" 	<span class=\"Share_Action offset_by_three_columns three_columns ignore_break_point\">" + 
		"			<label></label>" + 
		" 	</span>" + 
		" </div>" + 
		" </li>"
		).appendTo($Event_List);
};